(() => {
  function init(root) {
    if (root.dataset.lotrReady) return;
    root.dataset.lotrReady = 'true';
    const all = selector => [...root.querySelectorAll(selector)];
    const views = all('[data-lotr-view]');
    const viewButtons = all('[data-lotr-view-button]');
    const sceneButtons = all('[data-lotr-scene-button]');
    const scenePanel = root.querySelector('[data-lotr-scene-panel]');
    viewButtons.forEach(button => button.addEventListener('click', () => {
      const selected = Number(button.dataset.lotrViewButton);
      views.forEach((image, index) => { image.hidden = index !== selected; });
      viewButtons.forEach((item, index) => { item.setAttribute('aria-pressed', String(index === selected)); });
      sceneButtons.forEach(item => { item.hidden = Number(item.dataset.sceneView) !== selected + 1; item.setAttribute('aria-expanded','false'); });
      scenePanel.hidden = true;
      scenePanel.replaceChildren();
    }));
    sceneButtons.forEach(button => button.addEventListener('click', () => {
      const selected = Number(button.dataset.lotrSceneButton);
      const template = root.querySelector('[data-lotr-scene-template="' + selected + '"]');
      if (!template) return;
      scenePanel.replaceChildren(template.content.cloneNode(true));
      scenePanel.hidden = false;
      sceneButtons.forEach(item => item.setAttribute('aria-expanded', String(item === button)));
      scenePanel.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'nearest'});
    }));
    const board = root.querySelector('.life-board');
    const onImage = root.querySelector('[data-lotr-on]');
    const offImage = root.querySelector('[data-lotr-off]');
    const lightButtons = all('[data-lotr-light]');
    const onAlt = onImage.getAttribute('alt');
    const offAlt = offImage.dataset.alt;
    lightButtons.forEach(button => button.addEventListener('click', () => {
      const on = button.dataset.lotrLight === 'on';
      board.dataset.lit = String(on);
      onImage.setAttribute('alt', on ? onAlt : '');
      onImage.setAttribute('aria-hidden', String(!on));
      offImage.setAttribute('alt', on ? '' : offAlt);
      offImage.setAttribute('aria-hidden', String(on));
      lightButtons.forEach(item => item.setAttribute('aria-pressed', String((item.dataset.lotrLight === 'on') === on)));
      root.querySelector('[data-lotr-light-status]').textContent = on ? 'Lights on' : 'Lights off';
    }));
    const included = root.querySelector('[data-gob-included-inline]');
    if (included) {
      const variants = JSON.parse(included.querySelector('[data-gob-included-variants]').textContent);
      const productRoot = document.querySelector('[data-gob-daylight]');
      const select = productRoot?.querySelector('[data-product-select]');
      const update = id => {
        const variant = variants.find(x => String(x.id) === String(id));
        const tab = variant?.tab || 0;
        included.querySelectorAll('[data-gob-included-tab]').forEach(panel => { panel.hidden = Number(panel.dataset.gobIncludedTab) !== tab; });
        included.querySelector('[data-gob-included-unknown]').hidden = Boolean(tab);
        included.querySelector('[data-gob-included-version]').textContent = variant?.title || '';
        included.querySelectorAll('[data-gob-included-version-id]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.gobIncludedVersionId === String(id))));
      };
      update(select?.value || variants[0]?.id);
      included.querySelectorAll('[data-gob-included-version-id]').forEach(button => button.addEventListener('click', () => {
        const variant = variants.find(x => String(x.id) === button.dataset.gobIncludedVersionId);
        if (!variant) return;
        update(variant.id);
        const radio = [...(productRoot?.querySelectorAll('.d-v input[type="radio"]') || [])].find(x => x.value === variant.title);
        if (radio && !radio.disabled) radio.click();
      }));
      document.addEventListener('variant:change', event => {
        const variant = event.detail?.variant;
        if (variant && variants.some(x => String(x.id) === String(variant.id))) update(variant.id);
      });
    }
    const dialog = root.querySelector('.lotr-video-dialog');
    const container = root.querySelector('.lotr-video-container');
    let opener;
    root.querySelector('[data-lotr-video-open]').addEventListener('click', event => {
      const button = event.currentTarget;
      let url;
      try { url = new URL(button.dataset.videoUrl); } catch { return; }
      if (!['youtube.com','www.youtube.com','youtu.be'].includes(url.hostname)) return;
      const id = url.hostname === 'youtu.be' ? url.pathname.slice(1) : url.searchParams.get('v');
      if (!/^[a-zA-Z0-9_-]{11}$/.test(id || '')) return;
      const frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      frame.title = root.dataset.set + ' product video';
      frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      frame.allowFullscreen = true;
      container.replaceChildren(frame);
      opener = button;
      dialog.showModal();
      root.querySelector('[data-lotr-video-close]').focus();
    });
    root.querySelector('[data-lotr-video-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => { container.replaceChildren(); opener?.focus({preventScroll:true}); });
  }
  const start = () => document.querySelectorAll('[data-gob-lotr-story]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
